import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Chart, Pie } from "react-chartjs-2";
ChartJS.register(ArcElement, Tooltip, Legend);

function PieChart({ data }) {

  let chartData
  let options
  if ((data.values[0] === 0 && data.values[1] === 0 && data.values[2] === 0)
    || (data.values[0] === 0 && data.values[1] === 0)) {
    chartData = {
      labels: ['ไม่มีข้อมูล'],
      datasets: [
        {
          label: "",
          data: [1],
          backgroundColor: '#A2B5BC',
        }
      ]
    }
  }
  else {
    chartData = {
      labels: (data.values.length === 3) ?
        ['Slow', 'Intermediate', 'Rapid'] : ['Positive', 'Negative']
      ,
      datasets: [
        {
          label: "",
          data: data.values,
          // data: data.values,
          backgroundColor: (data.values.length === 3) ?
            ['#F19898', '#FFBA9B', '#82CDDD',]
            :
            ['#F19898', '#EFF198',],
          hoverBackgroundColor: (data.values.length === 3) ?
            ['#F19898', '#FFBA9B', '#82CDDD',]
            :
            ['#F19898', '#EFF198',],
          offset: 3
        }
      ],
    }

    options = {
      plugins: {
        legend: {
          labels: {
            boxWidth: 20,
            boxHeight: 20,
            padding: 20,
            font: {
              family: 'Sarabun',
              size: 16
            }
          },
          position: 'bottom'
        },
        tooltip: {
          callbacks: {
            label: ((chartData) => {
              let dataIndex = chartData.dataIndex
              let data = chartData.dataset.data[dataIndex]

              let total = 0
              chartData.dataset.data.forEach(data => {
                total = total + data
              });

              let dataPercent  = (data * 100)/total
              return ` ${chartData.formattedValue} ( ${dataPercent.toFixed(2)} %)`
            })
          },
          displayColors: false
        }
      }
    }
  }

  return (
    <Pie
      data={chartData}
      options={options}
    />
  )
}
export default PieChart;